import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Typography from '@mui/material/Typography';
export type VehicleAttributeProps = {
  title?: React.ReactNode;
  caption?: React.ReactNode;
};
export function VehicleAttribute(t0) {
  const $ = _c(7);
  const {
    title,
    caption
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <Typography variant="body1">{title}</Typography>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== caption) {
    t2 = <Typography variant="caption">{caption}</Typography>;
    $[2] = caption;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}